import { render, staticRenderFns } from "./lookup-spu.vue?vue&type=template&id=28d61b10&"
import script from "./lookup-spu.vue?vue&type=script&lang=js&"
export * from "./lookup-spu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports